/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIWasteRequest
 */
export interface APIWasteRequest {
    /**
     * 
     * @type {string}
     * @memberof APIWasteRequest
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof APIWasteRequest
     */
    comment: string;
}

/**
 * Check if a given object implements the APIWasteRequest interface.
 */
export function instanceOfAPIWasteRequest(value: object): value is APIWasteRequest {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function APIWasteRequestFromJSON(json: any): APIWasteRequest {
    return APIWasteRequestFromJSONTyped(json, false);
}

export function APIWasteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIWasteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'comment': json['comment'],
    };
}

export function APIWasteRequestToJSON(value?: APIWasteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'comment': value['comment'],
    };
}

